var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.335938 5.24577H1.66927V8.5791H12.3359V5.24577H13.6693V8.5791C13.6693 8.93272 13.5288 9.27186 13.2787 9.52191C13.0287 9.77196 12.6896 9.91244 12.3359 9.91244H1.66927C1.31565 9.91244 0.97651 9.77196 0.726462 9.52191C0.476413 9.27186 0.335938 8.93272 0.335938 8.5791M6.33594 0.579102H7.66927V2.5791H9.66927V3.91244H7.66927V5.91244H6.33594V3.91244H4.33594V2.5791H6.33594V0.579102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.549cb8d6a465273d7f10fa895c0f5a43.svg";
export { ForwardRef as ReactComponent };